import { useI18n } from '../../i18n.js';

export function LandingFaq() {
  const { lang, t } = useI18n();
  const isMn = lang === 'mn';

  return (
    <section className="landing-section" id="faq" aria-label={t.landingFaqTitle}>
      <div className="landing-section-header">
        <h2>{t.landingFaqTitle}</h2>
        <p>{t.landingFaqSubtitle}</p>
      </div>

      <div className="faq-grid">
        <details className="faq-item" open>
          <summary className="faq-summary">
            {isMn ? 'Тоглоом үнэгүй юу?' : 'Is arvangurav.com free to play?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? 'Тийм ээ, бүрэн үнэгүй! Найзуудтайгаа болон ботуудтай хүссэн үедээ чөлөөтэй тоглоно. Мөн шинэ бүртгэлд 100 Цай бэлгэнд олгогдоно.'
              : 'Yes! Casual play with friends and bots is 100% free with no limits, and you receive 100 free Tsai upon registering.'}
          </p>
        </details>

        <details className="faq-item">
          <summary className="faq-summary">
            {isMn ? 'Найзуудаа хэрхэн урих вэ?' : 'How do I invite and play with friends?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? 'Өрөө үүсгээд дэлгэцийн дээрх 4 оронтой код эсвэл холбоосыг найздаа илгээхэд л шууд нэгдэнэ.'
              : 'Create a room and send the 4-letter code or invite link to friends to connect instantly.'}
          </p>
        </details>

        <details className="faq-item">
          <summary className="faq-summary">
            {isMn ? 'Гар утсан дээр тоглож болох уу?' : 'Can I play on smartphones and tablets?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? 'Тийм! iPhone, Android болон таблетуудын хөтөч дээр ямар ч апп таталгүйгээр шууд төгс ажиллана.'
              : 'Yes! Fully responsive and touch-optimized for mobile browsers with zero downloads required.'}
          </p>
        </details>

        <details className="faq-item">
          <summary className="faq-summary">
            {isMn ? 'Цай (Tsai) оноо гэж юу вэ, яаж авах вэ?' : 'What are Tsai tokens and how do I earn them?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? 'Өрсөлдөөнт өрөөний виртуал оноо юм. Шинэ бүртгэлд 100 Цай олгогдож, хожсоноор оноогоо өсгөнө.'
              : 'Virtual tokens for competitive matches. Start with 100 free tokens and earn more by winning.'}
          </p>
        </details>

        <details className="faq-item">
          <summary className="faq-summary">
            {isMn ? 'Муушиг ба Арван гуравын дүрэм ямар ялгаатай вэ?' : 'What is the difference between Big Two and Muushig?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? 'Арван гурав нь 13 модоо хослолоор түрүүлж гаргах, харин Муушиг нь хөзрийн өнгөөр гэр авч 15-аас 0 оноонд хүрэх тоглоом юм.'
              : 'Big Two is a 13-card climb-and-shed game, while Muushig is a 32-card trick game played down from 15 to 0.'}
          </p>
        </details>

        <details className="faq-item">
          <summary className="faq-summary">
            {isMn ? 'VIP гишүүнчлэлд юу багтдаг вэ?' : 'What perks come with VIP membership?'}
          </summary>
          <p className="faq-content">
            {isMn
              ? '7 хоног бүр +160 Цай, өрөөний дуут яриа (Voice chat), өрөөндөө тусгай нэр өгөх болон тансаг хөзрийн ар загварууд багтана.'
              : 'Includes +160 weekly tokens, in-room voice chat, vanity room names, and exclusive card back designs.'}
          </p>
        </details>
      </div>
    </section>
  );
}
